import { Pause } from 'iconsax-react';
import PlayIcon from '@/assets/images/icons/play.svg?react';
import DurationDisplay from '@/components/common/duration-display';
import AudioBars from '@/components/common/media-content/audio-bars';
import { useAudioControls } from '@/hooks/conversations/use-audio-controls';
import { useSafeMediaUrl } from '@/hooks/use-safe-media-url';
import cn from '@/utils/merge-class-names';

interface Props {
  src: string;
  className?: string;
  barCount?: number;
  compact?: boolean;
}

export default function AudioPlayer({ barCount, src, className, compact }: Props) {
  const [audioSrc, ...rest] = src.split('|');
  const duration = Number.parseInt(rest.at(-1) ?? '0');

  const { src: safeSrc } = useSafeMediaUrl(audioSrc);
  const { ref, toggle, position, progress, isPlaying, isLoading, isExpired } = useAudioControls(safeSrc);

  return (
    <>
      <button
        type='button'
        onClick={toggle}>
        <div
          className={cn(
            'flex items-center gap-1.5 min-w-min p-4',
            isExpired && 'opacity-50 cursor-not-allowed',
            className,
          )}>
          {isLoading ? (
            <span className='loading loading-spinner' />
          ) : isPlaying ? (
            <Pause
              variant='Bold'
              className='size-5'
            />
          ) : (
            <PlayIcon className='size-5' />
          )}

          <AudioBars
            count={barCount}
            progress={progress}
            duration={duration}
            className={cn(
              isExpired
                ? 'bg-neutral-400 group-data-sender:bg-neutral-300'
                : 'bg-neutral-800 group-data-sender:bg-body',
            )}
          />

          <DurationDisplay
            withUnits={false}
            compact={compact}
            className='text-body2 desktop:text-body3 text-body'
            duration={isPlaying && position ? position : duration}
          />
        </div>
      </button>

      <audio
        ref={ref}
        src={safeSrc}
        className='hidden'
        autoPlay={false}
        controls={false}
        preload='none'
      />
    </>
  );
}
